export default {
  api: {
    url: null
  },
  favicon: 'favicon.ico',
};
